import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromShared from '../reducers/shared.reducer';

export const selectState = createFeatureSelector<fromShared.State>(
  fromShared.featureKey
);

export const getLoading = createSelector(selectState, (state) => state.showLoading);
export const selectCapturedImage = createSelector(selectState, (state) => state.capturedImage);
export const getShowBackFront = createSelector(selectState, (state) => state.showBackFront);
